<template>
    <div class="Summary" v-if="RecordData.Id">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Family Info</h4>
                        <p><span class="bold">Family Name: </span><span>{{ RecordData.Name }}</span></p>
                        <p><span class="bold">Territory: </span><span>{{ RecordData.SubProgramTerritory.Name }}</span></p>
                        <p><span class="bold">Address: </span><span>{{ RecordData.PhysicalAddress.AddressSingleLine }}</span> <GoogleMapsLink v-bind:address="RecordData.PhysicalAddress" /></p>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>People</h4>
                        <div v-for="client in RecordData.Clients">
                            <p><span class="bold">{{ client.Client.Person.FullName }}</span><span> ({{ client.Client.ClientType }})</span></p>
                            <p v-if="client.Client.Person.Email" style="margin-left:20px;"><a :href="'mailto:' + client.Client.Person.Email">{{client.Client.Person.Email}}</a></p>
                            <p v-for="(phoneNumber, phoneIndex) in client.Client.Person.PhoneNumbers" style="margin-left:20px;">
                                <span>{{ phoneNumber.PhoneNumber.PhoneType }}: </span><a :href="'tel:' + phoneNumber.PhoneNumber.PhoneNumberDigits">{{ phoneNumber.PhoneNumber.FormattedPhoneNumber }}</a> {{ phoneNumber.PhoneNumber.Description ? '(' + phoneNumber.PhoneNumber.Description + ')' : '' }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    export default {
        props: [
            'RecordData'
        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            formatDate (value, fmt = 'MM/DD/YY', defaultText = '') {
              return (value == null)
                ? defaultText
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            
        },
        components: {
            GoogleMapsLink
        },
        mounted() {
        },
        computed: {
            
        }
    }
</script>

<style scoped>
</style>